import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=2fc37c10&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"
import style0 from "./Filter.vue?vue&type=style&index=0&id=2fc37c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc37c10",
  null
  
)

export default component.exports